import axios from "axios";
import baseUrl from "../constants/baseUrl";
import * as Sentry from "@sentry/react";

export const getBusinessAverageDeliveries =
  (setBusinessAverageDeliveries) => async (dispatch) => {
    try {
      const { data } = await axios.post(
        `${baseUrl}Auth/GetBusinessAverageDeliveries`,
        {}
      );
      setBusinessAverageDeliveries(data);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

export const getBusinessCurrentIndustry =
  (setBusinessCurrentIndustry) => async (dispatch) => {
    try {
      const { data } = await axios.post(
        `${baseUrl}Auth/GetBusinessCurrentIndustry`,
        {}
      );
      setBusinessCurrentIndustry(data);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

export const getBusinessGeneralLeadTime =
  (setBusinessGeneralLeadTime) => async (dispatch) => {
    try {
      const { data } = await axios.post(
        `${baseUrl}Auth/GetBusinessGeneralLeadTime`,
        {}
      );
      setBusinessGeneralLeadTime(data);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

export const getBusinessOrderPreference =
  (setBusinessOrderPreference) => async (dispatch) => {
    try {
      const { data } = await axios.post(
        `${baseUrl}Auth/GetBusinessOrderPreference`,
        {}
      );
      setBusinessOrderPreference(data);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

export const getBusinessPreferedContactMethod =
  (setBusinessPreferedContactMethod) => async (dispatch) => {
    try {
      const { data } = await axios.post(
        `${baseUrl}Auth/GetBusinessPreferedContactMethod`,
        {}
      );
      setBusinessPreferedContactMethod(data);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

export const getBusinessVehicleOftenRequired =
  (setBusinessVehicleOftenRequired) => async (dispatch) => {
    try {
      const { data } = await axios.post(
        `${baseUrl}Auth/GetBusinessVehicleOftenRequired`,
        {}
      );
      setBusinessVehicleOftenRequired(data);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

export const postBookingSignup =
  (businessObject, history) => async (dispatch) => {
    try {
      await axios.post(`${baseUrl}Auth/BusinessSignup`, businessObject);
      localStorage.setItem("currentBookingType", "Business");
      history.push("/booking");
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };
